import { ICreateInternalNote } from '@sdk/contracts';
import { dateProvider } from '@utils';
import { Form, FormInstance, Input } from 'antd';
import { useTranslation } from 'react-i18next';

import { HideToTeachersSwitch } from './HideToTeachersSwitch';
import { NoteDetailWrapper, Wrapper } from './InternalNoteForm.styles';

import { HtmlEditor, InternalNoteTypeSelector } from '@/components/Form';
import { RULES } from '@/constants';
import { useInternalNotesForm } from '@/hooks';
import { useProfile } from '@/store';

type Props = {
  form: FormInstance;
  onFinish: (values: ICreateInternalNote) => void;
};

export const InternalNoteForm: React.FC<Props> = ({ form, onFinish }) => {
  const { t } = useTranslation('ChatTranslations');
  const { internalNote } = useInternalNotesForm();
  const {
    roleCheck: { isTeacher }
  } = useProfile();

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Wrapper>
        <Form.Item name="_id" hidden>
          <Input />
        </Form.Item>
        <Form.Item name="title" rules={[RULES.REQUIRED]}>
          <Input size="large" variant="borderless" placeholder={t('TITLE')} />
        </Form.Item>
        <Form.Item name="type">
          <InternalNoteTypeSelector />
        </Form.Item>
        {internalNote && (
          <NoteDetailWrapper>
            <div>
              {t('CREATED_BY', {
                name: `${internalNote.createdBy.name} ${internalNote.createdBy.lastName}`
              })}
            </div>
            <div>
              {t('LAST_UPDATED_ON', {
                date: dateProvider.format(internalNote.updatedAt, 'dd MMM yyyy, HH:mm')
              })}
            </div>
          </NoteDetailWrapper>
        )}
        {!isTeacher && (
          <Form.Item
            name="isForManagers"
            initialValue={internalNote?.isForManagers ?? true}
            rules={[RULES.REQUIRED]}>
            <HideToTeachersSwitch />
          </Form.Item>
        )}
        <Form.Item name="content">
          <HtmlEditor placeholder={t('WRITE_HERE_YOUR_NOTE')} />
        </Form.Item>
        <Form.Item name="highlightedBy" hidden>
          <Input />
        </Form.Item>
      </Wrapper>
    </Form>
  );
};
